import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import App from "./App";
import IrisDemo from "./iris/IrisDemo";

// Discreet floating entry to the IRIS demo, shown over the guildes page.
function IrisFab() {
  return (
    <Link
      to="/iris"
      title="Demande à IRIS"
      style={{
        position: "fixed",
        right: 18,
        bottom: 18,
        zIndex: 9999,
        textDecoration: "none",
        background: "linear-gradient(90deg,#ff5f6d,#ffc371,#47e891,#2bd2ff,#845ec2)",
        backgroundSize: "200% auto",
        color: "#fff",
        fontWeight: 700,
        padding: "0.6rem 1rem",
        borderRadius: 999,
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
      }}
    >
      🌈 IRIS
    </Link>
  );
}

// Served under a sub-path? PUBLIC_URL (set at build, e.g. "/iris") drives both the
// asset prefix and the router basename so deep links resolve under that path.
const BASENAME = process.env.PUBLIC_URL || undefined;
// Standalone mode: IRIS is its own tool (e.g. opal.nech.pl/iris) - render only IRIS,
// no guildes app. Set REACT_APP_IRIS_STANDALONE=1 at build time.
const STANDALONE = process.env.REACT_APP_IRIS_STANDALONE === "1";

const root = createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <BrowserRouter basename={BASENAME}>
      {STANDALONE ? (
        <Routes>
          <Route path="*" element={<IrisDemo />} />
        </Routes>
      ) : (
        <Routes>
          <Route
            path="/"
            element={
              <>
                <App />
                <IrisFab />
              </>
            }
          />
          <Route path="/iris" element={<IrisDemo />} />
        </Routes>
      )}
    </BrowserRouter>
  </StrictMode>
);
